import { Reveal } from "@/components/motion/Reveal";

export const SectionIntro = ({ eyebrow, title, children, tone = "dark", className = "", testid }) => {
  const dark = tone === "dark";
  return (
    <div className={`max-w-3xl ${className}`} data-testid={testid}>
      {eyebrow && (
        <Reveal as="p" className={`eyebrow flex items-center gap-3 ${dark ? "text-gold" : "text-plum-2"}`}>
          <span className={`h-px w-10 ${dark ? "bg-gold" : "bg-plum-2"}`} /> {eyebrow}
        </Reveal>
      )}
      <Reveal as="h2" delay={0.05} className={`mt-6 font-display text-[2.2rem] font-light leading-[1.05] tracking-[-0.02em] sm:text-5xl lg:text-[3.6rem] ${dark ? "text-white" : "text-ink"}`}>
        {title}
      </Reveal>
      {children && (
        <Reveal delay={0.1} className={`mt-6 space-y-4 text-base leading-relaxed md:text-lg ${dark ? "text-white/75" : "text-ink/75"}`}>
          {children}
        </Reveal>
      )}
    </div>
  );
};
